import Link from 'next/link'
import { signOut } from "next-auth/react"
import Router from 'next/router'
import Cap from '@/frontend/components/qecomps/Cap'
import { setCookie, getCookie } from 'cookies-next';
import { SSRGlobal } from '../qecomps/Context';
import Img from '../qecomps/Img';
// import news from '@/frontend/news.webp'
import news from '@/frontend/base64/news.img'
import myapps from '@/frontend/base64/workspace.img'
import account from '@/frontend/base64/account.image'
import transactionsimg from '@/frontend/base64/transactions.image'
import logoutimg from '@/frontend/base64/logout.image'
import messageimg from '@/frontend/base64/message.image'
import sz from '@/frontend/base64/sz.img'
import depositimg from '@/frontend/base64/deposit.img'
import transferimg from '@/frontend/base64/transfer3.img'
import withdrawimg from '@/frontend/base64/withdraw.img'
import Ico from '../qecomps/Ico';
import WindowFloatModal from '../qecomps/WindowFloatModal';
import { motion } from "framer-motion";
import Copy from '../qecomps/Copy';


const changeLang = (code) => {
  let restofpath = Router.asPath.slice(3);
  // Router.push("/" + props.code + restofpath)
  window.location.href = "/" + code + restofpath
}
export const MenuFunc = async (top: boolean = false) => {

  let z = SSRGlobal();

  await modaler((props, refresh, resolve, attributes) => {
    if (top) {
      if (props.top != 60)
        setTimeout(() => {
          props.top = 60
          refresh()
        }, 10);
    }
    else {
      if (props.bottom != 80)
        setTimeout(() => {
          props.bottom = 80
          refresh()
        }, 10);
    }
    if (!attributes.maxWidth)
      attributes.maxWidth = 900
    if (top) {
      attributes.style.top = props.top || "50%";
      attributes.style.bottom = null
    }
    else {
      attributes.style.bottom = props.bottom || "50%";
      attributes.style.top = null;
    }
    attributes.style.left = "50%"

    attributes.style.transform = "translate(-50%, 0)"
    attributes.style.transformOrigin = 0

    if (innerWidth > 1000 && !props.wide) {
      attributes.style.maxHeight = 80
      attributes.style.overflowY = "hidden"
    }
    else {
      attributes.style.maxHeight = "80vh"
      attributes.style.overflowY = "scroll"
    }


    return <w-cse style={{ rowGap: 10, padding: 5 }}>

      {props.form == "financial" ? <>
        <Ico on={async () => { if (z.user?.uid) Router.push(z.root + "/deposits"); else global.login(); resolve() }} icon="icon-[hugeicons--money-add-02] w-[35px] h-[35px] " text={z.lang.deposit} />
        <Ico on={async () => { if (z.user?.uid) Router.push(z.root + "/withdrawals"); else global.login(); resolve() }} icon="icon-[fluent--money-hand-20-regular] w-[35px] h-[35px] " text={z.lang.withdraw} />
        <Ico on={async () => { if (z.user?.uid) Router.push(z.root + "/transfer"); else global.login(); resolve() }} icon="icon-[hugeicons--money-exchange-03] w-[35px] h-[35px] " text={z.lang.transfer} />
        <Ico on={async () => { if (z.user?.uid) Router.push(z.root + "/transactions"); else global.login(); resolve() }} icon="icon-[fluent--receipt-money-24-regular] w-[35px] h-[35px] " text={z.lang.transactions} />

        {/* <Ico on={async () => { resolve() }} icon="icon-[fluent--money-16-regular] w-[35px] h-[35px] " text={`موجودی`} /> */}
        <Ico on={async () => { attributes.maxWidth = 900; refresh({ form: null }, innerWidth > 1000); }} icon="icon-[lets-icons--return-light] w-[35px] h-[35px] " text={z.lang.back} />

      </> : null}

      {props.form == "developers" ? <>
        <Ico on={async () => { if (z.user?.uid) linkpicker().then(async _ => { if (_) { Copy(_) } }); else login(); resolve() }} icon="icon-[solar--gallery-minimalistic-outline] " text={z.lang.iconlist} />
        <Ico on={async () => { if (z.user?.uid) Router.push(z.root + "/onlines"); else global.login(); resolve() }} icon="icon-[heroicons-outline--status-online] w-[35px] h-[35px] " text={z.lang.onlinelist} />
        <Ico on={async () => { }} icon="icon-[solar--document-text-outline] w-[35px] h-[35px] " text={z.lang.docs} />
        {z.user.role.includes("admin") ? <Ico on={async () => { Router.push(z.root + "/admin"); }} icon="icon-[material-symbols-light--admin-panel-settings-outline-rounded] w-[35px] h-[35px] " text={"admin"} /> : null}
        <Ico on={async () => { Router.push(z.root + "/links"); resolve() }} icon="icon-[quill--link]" text={"لینک کوتاه"} />
        {z.user.role?.includes?.("admin") || z.user.role?.includes?.("student") ? <Ico on={async () => { Router.push(z.root + "/linkpays"); resolve() }} icon="icon-[hugeicons--money-send-square] w-[30px] h-[30px]" text={"لینک پرداخت"} /> : null}
        {z.user.role?.includes?.("admin") || z.user.role?.includes?.("student") ? <Ico on={async () => { Router.push(z.root + "/infraneeds"); resolve() }} icon="icon-[carbon--development] w-[28px] h-[28px]" text={"توسعه زیرساخت"} /> : null}
        
        <Ico on={async () => { attributes.maxWidth = 900; refresh({ form: null }, innerWidth > 1000); }} icon="icon-[lets-icons--return-light] w-[35px] h-[35px] " text={z.lang.back} />

      </> : null}

      {props.form == "languages" ? <>
        <Ico on={async () => { changeLang("ar"); resolve() }} icon="icon-[emojione-v1--flag-for-saudi-arabia] w-[35px] h-[35px]  " text={`Arabic`} />
        <Ico on={async () => { changeLang("en"); resolve() }} icon="icon-[twemoji--flag-united-states] w-[35px] h-[35px]  " text={`English`} />
        <Ico on={async () => { changeLang("fa"); resolve() }} icon="icon-[twemoji--flag-iran] w-[35px] h-[35px]  " text={`Persian`} />
        <Ico on={async () => { changeLang("zh"); resolve() }} icon="icon-[twemoji--flag-china] w-[35px] h-[35px]  " text={`Chinese`} />
        <Ico on={async () => { changeLang("ru"); resolve() }} icon="icon-[twemoji--flag-russia] w-[35px] h-[35px]  " text={`Russian`} />
        <Ico on={async () => { changeLang("de"); resolve() }} icon="icon-[emojione-v1--flag-for-germany] w-[35px] h-[35px]  " text={`Deutsch`} />
        <Ico on={async () => { changeLang("fr"); resolve() }} icon="icon-[twemoji--flag-france] w-[35px] h-[35px]  " text={`Français`} />
        <Ico on={async () => { changeLang("es"); resolve() }} icon="icon-[emojione-v1--flag-for-spain] w-[35px] h-[35px]  " text={`Español`} />
        <Ico on={async () => { changeLang("ja"); resolve() }} icon="icon-[twemoji--flag-japan] w-[35px] h-[35px]  " text={`Japanese`} />
        <Ico on={async () => { changeLang("ko"); resolve() }} icon="icon-[emojione-v1--flag-for-south-korea] w-[35px] h-[35px]  " text={`Korean`} />
        <Ico on={async () => { changeLang("pt"); resolve() }} icon="icon-[emojione-v1--flag-for-brazil] w-[35px] h-[35px]  " text={`Português`} />
        <Ico on={async () => { changeLang("tr"); resolve() }} icon="icon-[emojione-v1--flag-for-turkey] w-[35px] h-[35px]  " text={`Turkey`} />
        <Ico on={async () => { changeLang("ur"); resolve() }} icon="icon-[emojione-v1--flag-for-pakistan] w-[35px] h-[35px]  " text={`Urdu`} />
        <Ico on={async () => { changeLang("id"); resolve() }} icon="icon-[emojione-v1--flag-for-indonesia] w-[35px] h-[35px]  " text={`Bahasa`} />
        <Ico on={async () => {

          if (innerWidth > 1000) {
            refresh({ wide: false });
            setTimeout(() => {
              attributes.maxWidth = 900;
              refresh({ form: null }, true)
            }, 200);
          }
          else {
            refresh({ form: null })
          }

        }} icon="icon-[lets-icons--return-light] w-[35px] h-[35px] " text={z.lang.back} />

      </> : null}


      {!props.form ? <>
        <Ico on={async () => { if (z.user?.uid) Router.push(z.root + "/account"); else global.login(); resolve() }} icon="icon-[lineicons--user-4] w-[35px] h-[35px]" text={z.lang.account} />
        <Ico on={async () => { Router.push(z.root + "/explore"); resolve() }} icon="icon-[fluent--copy-select-24-regular] w-[35px] h-[35px]" text={z.lang.services} />
        <Ico on={async () => { if (z.user?.uid) Router.push(z.root + "/app"); else global.login(); resolve() }} icon="icon-[fluent--rectangle-landscape-32-regular] w-[35px] h-[35px]" text={z.lang.myapps} />
        <Ico on={async () => { Router.push(z.root); resolve() }} icon="icon-[solar--screencast-outline] w-[35px] h-[35px]" text={z.lang.medianews} />
        <Ico on={async () => { attributes.maxWidth = 500; refresh({ form: "financial" }, false) }} icon="icon-[solar--wallet-money-outline] w-[35px] h-[35px]" text={z.lang.financial} />
        <Ico on={async () => { if (z.user?.uid) Router.push(z.root + "/chats"); else global.login(); resolve() }} icon="icon-[mage--message-dots] w-[35px] h-[35px]" text={z.lang.messages} />
        <Ico on={async () => { attributes.maxWidth = z.user.role.includes("admin") ? 800 : 700; refresh({ form: "developers" }, false) }} icon="icon-[lets-icons--code] w-[35px] h-[35px]" text={z.lang.developers} />
        <Ico on={async () => {
          attributes.maxWidth = 500; refresh({ form: "languages" }, innerWidth > 1000); setTimeout(() => {
            refresh({ wide: true })
          }, 500);
        }} icon="icon-[material-symbols--language-japanese-kana-rounded] w-[35px] h-[35px]" text={z.lang.language} />
        {z.user?.uid ? <Ico on={async () => {
          signOut()
        }} icon="icon-[solar--exit-outline] w-[35px] h-[35px]" text={z.lang.logout} /> : null}
      </> : null}

    </w-cse>


  }, {})
}
